
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"11","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7.467 0c1.12 0 1.68 0 2.108.218a2 2 0 01.874.874c.217.427.218.987.218 2.107v4.268c0 1.12 0 1.68-.218 2.108a2 2 0 01-.874.874c-.428.217-.988.218-2.108.218H3.2c-1.12 0-1.68 0-2.107-.218a2 2 0 01-.874-.874C0 9.147 0 8.587 0 7.467V3.2c0-1.12 0-1.68.218-2.107a2 2 0 01.874-.874C1.519 0 2.079 0 3.199 0h4.268zM3.333 4.667a.667.667 0 100 1.333h4a.667.667 0 000-1.333h-4z","fill":"#888"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      